import React from 'react';
import { View } from 'react-native';
import { connect } from 'react-redux';

import {
  isWeb,
  navigateTo,
  isPhone,
  Popup,
  getLinkingModalConfig,
  machineDetailsConditions,
  machineStatusColorName,
  machineStatus,
  triggerRemovePI,
} from '../../../../helpers';
import { scale, fullWidth } from '@components/frame';
import ActionMenu from '@components/common/actionMenu';
import ColorWrapper from '@styles/colors';

import NCFileType from '@components/common/NCFileType';
import { useHandleNavigationMachinesHeader } from '@v2/pages/machines/hooks/useHandleNavigationMachineHeader';
import { setActionsModalOpen, setIsRemovingPI } from '@reducers/machinesV2';
import { getNCFileById, removeProductionInformation } from '@reducers/manufacture';
import { useHandleParams } from '@v2/pages/machines/hooks/useHandleParams';
import ModalWrapper from '@components/modal/ModalWrapper';
import { NowSubScreen } from '@v2/pages/machines/common/enums';
import { setIsEditModeForPartSwitchOn } from '@reducers/details';
import { generateNCFileURL } from '@reducers/blobStorage';
import { shareNCFile } from '@components/common/NCFile/helpers';

const ActionsModal = (props) => {
  const {
    panelViewMode,
    setActionsModalOpen,
    C,
    selectedItem,
    user: { featureFlags },
    actionsModalOpen,
    isRemovingPI,
    setIsRemovingPI,
    removeProductionInformation,
    setIsEditModeForPartSwitchOn,
    top,
    right,
    generateNCFileURL,
    getNCFileById,
  } = props;

  const { status, subStatus, ncFileStatus, ncFile } = selectedItem?.machineStatus || {};

  const { machineActive, ignoredNcFile } = machineDetailsConditions({
    status,
    ncFileStatus,
    subStatus,
    ncFileExist: !!ncFile,
  });

  const { isNowSubScreen, activeLevelScreenName } = useHandleNavigationMachinesHeader();

  const isNowPartScreen = activeLevelScreenName === NowSubScreen.PART;
  const ncFileExist = !!ncFile;

  const { isAllSelected: allSelected } = useHandleParams();

  const onDownloadNCFilePress = () => {
    shareNCFile({ generateNCFileURL, selectedItem, getNCFileById, isDetailsScreen: false, ncFileData: null });
  };

  const items = [
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Modify NC File Type',
      },
      icons: [
        {
          name: 'linked',
          width: 13,
          height: 13,
          color: machineStatusColorName[machineStatus.ACTIVE],
        },
        {
          name: 'change',
          width: 13,
          height: 13,
          color: machineStatusColorName[machineStatus.CHANGE],
        },
        {
          name: 'ignore',
          width: 13,
          height: 13,
          color: machineStatusColorName[machineStatus.NOTPRODUCTIVE],
        },
      ],
      iconsGap: 6,
      hide: !featureFlags['ncfile-update-nc-file-type'] || !selectedItem?.machineStatus?.ncFileId || !isNowSubScreen,
      onPress: () => {
        setActionsModalOpen(false);
        Popup({
          Component: (p) => <NCFileType {...{ ...p, selectedItem, context: 'batch' }} />,
          ...getLinkingModalConfig(scale, fullWidth),
        });
      },
    },
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Edit Part',
      },
      icon: {
        name: 'edit',
        width: isWeb ? 15 : 12,
        height: isWeb ? 15 : 12,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        setIsEditModeForPartSwitchOn(true);
      },
      hide: !isNowPartScreen || !ncFileExist,
    },
    // {
    //   lable: {
    //     color: 'Label/Light/Primary',
    //     name: 'Open Large View',
    //   },
    //   hide: isPhone || panelViewMode || !featureFlags['machine-panel'] || allSelected,
    //   icon: {
    //     name: 'expandView',
    //     width: 18,
    //     height: 18,
    //     color: 'Label/Light/Primary',
    //   },
    //   onPress: () => {
    //     setActionsModalOpen(false);
    //     navigateTo('PanelView', { id: selectedItem.id || selectedItem.machineId, level: 'part' });
    //   },
    // },

    {
      lable: {
        color: 'Label/Light/Primary',
        name: isWeb ? 'Download' : 'Share',
      },
      icon: {
        name: isWeb ? 'download' : 'share',
        width: 15,
        height: 18,
        color: 'Label/Light/Primary',
      },
      onPress: onDownloadNCFilePress,
      hide: !ncFileExist,
    },

    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Open Operator Panel',
      },
      hide: isPhone || panelViewMode || !featureFlags['machine-operator-panel'] || allSelected,
      icon: {
        name: 'operatorPanel',
        width: 19,
        height: 14,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        navigateTo('OperatorPanel', { id: selectedItem.id || selectedItem.machineId, hideNcFilePopup: true });
      },
    },
    {
      lable: {
        color: 'Label/Light/Warning',
        name: 'Clear NC File Type',
      },
      hide: (!machineActive && !ignoredNcFile) || allSelected,
      icon: {
        name: 'remove',
        width: isWeb ? 17 : 15,
        height: isWeb ? 18 : 17,
        color: 'Label/Light/Warning',
      },
      isLoading: isRemovingPI,
      onPress: () =>
        isRemovingPI
          ? null
          : triggerRemovePI({
              params: { ncFileId: selectedItem.machineStatus.ncFileId },
              removeProductionInformation,
              setActionsModalOpen,
              setIsRemovingPI,
            }),
    },
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Machine Settings',
      },
      icon: {
        name: 'menuCogSelected',
        width: 18,
        height: 18,
        color: 'Label/Light/Primary',
      },
      onPress: () => {
        setActionsModalOpen(false);
        if (allSelected) {
          navigateTo('Settings', { screen: 'Machines' });
        } else {
          navigateTo('Settings', {
            screen: 'Machines',
            params: {
              screen: 'MachineDetails',
              params: { id: selectedItem.id || selectedItem.machineId },
            },
          });
        }
      },
    },
    {
      lable: {
        color: 'Label/Light/Primary',
        name: 'Notification Settings',
      },
      hide: (!machineActive && !ignoredNcFile) || allSelected,
      icon: {
        name: 'chevronRight',
        width: 8,
        height: 8,
        color: 'Label/Light/Primary',
      },
      onPress: () => navigateTo('Settings', { screen: 'Notifications' }),
      divideSection: true,
    },
  ];

  const handleBackdropPress = () => {
    if (actionsModalOpen) {
      setActionsModalOpen(false);
    }
  };

  return (
    <ModalWrapper isVisible={actionsModalOpen} C={C} onBackdropPress={handleBackdropPress}>
      <View
        style={{
          position: 'absolute',
          top:
            scale(top != null ? top : typeof actionsModalOpen === 'number' ? actionsModalOpen : isWeb ? 125 : 80) + (panelViewMode ? scale(10) : 0),
          right: scale(right != null ? right : panelViewMode ? 70 : 18),
          backgroundColor: C('Background/Light/Field'),
          borderRadius: scale(12),
        }}
      >
        <ActionMenu {...{ C, items }} />
      </View>
    </ModalWrapper>
  );
};

const mapStateToProps = ({ user, machines: { selectedItem }, machinesV2: { actionsModalOpen, isRemovingPI } }) => ({
  user,
  isRemovingPI,
  actionsModalOpen,
  selectedItem,
});

export default connect(mapStateToProps, {
  setIsRemovingPI,
  removeProductionInformation,
  setActionsModalOpen,
  setIsEditModeForPartSwitchOn,
  generateNCFileURL,
  getNCFileById,
})(ColorWrapper(ActionsModal));
